package io.writeopia.ui.keyboard

enum class KeyboardEvent {
    DELETE, IDLE
}
